// extracted by mini-css-extract-plugin
module.exports = {"root":"Duration_root__2NxG_"};